import { render, staticRenderFns } from "./MemberPasswordVerify.vue?vue&type=template&id=60fa160e&scoped=true&"
import script from "./MemberPasswordVerify.vue?vue&type=script&lang=js&"
export * from "./MemberPasswordVerify.vue?vue&type=script&lang=js&"
import style0 from "./MemberPasswordVerify.vue?vue&type=style&index=0&id=60fa160e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fa160e",
  null
  
)

export default component.exports